import styles from "./FlexSystem.module.scss";
import React from "react";

export const FlexRow: React.FC = props => <div {...props} className={styles.row}/>
export const FlexColGrow: React.FC = props => <div {...props} className={styles.col}/>
